module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "container"
    }
  }, [_c('Navigator', {
    staticClass: "section"
  }), _vm._v(" "), _c('CarouselNew', {
    staticClass: "section",
    style: ({
      height: _vm.height
    })
  }), _vm._v(" "), _c('ProductCenter', {
    staticClass: "section",
    style: ({
      height: _vm.height
    })
  }), _vm._v(" "), _c('CustomerOpinions', {
    staticClass: "section",
    style: ({
      height: _vm.height
    })
  }), _vm._v(" "), _c('ContactUs', {
    staticClass: "section",
    style: ({
      height: _vm.height
    }),
    attrs: {
      "place": "index"
    }
  }), _vm._v(" "), _c('EnFooter', {
    staticClass: "section"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-43558786!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/app.vue
// module id = 406
// module chunks = 3